<p>
    The Faculty Courses widget lists sections taught by academic year. Information is pulled in real-time from our
    Canvas Learning Management System. If a course title is a blue link, you can click directly into Canvas.
    If a course title is black, the course has not been published in Canvas or does not use Canvas for
    course material.
</p>
<hr />
<p>Students, Roster and Biobook Buttons</p>
<p class="my-classes-biobooks">
    <button class="btn btn-sm btn-primary mr-1">Update Course Resources</button>
    <button class="btn btn-sm btn-primary mr-1">Students</button>
    <button class="btn btn-sm btn-primary mr-1" title="Roster Download">
        <i class="fas fa-file-csv"></i> Roster<span class="sr-only">Roster Download</span>
    </button>
    <button class="btn btn-sm btn-primary mr-1" title="Print Biobooks">
        <i class="fal fa-portrait"></i> Bios<span class="sr-only">Biobooks Download</span>
    </button>
</p>
<p>
  The Add/Update Course Resources and Students buttons show for current sections that have not ended and
  for future sections. The Roster and Biobook buttons will appear for all sections. The buttons do not show if
  you are the section's lead instructor.
</p>
